let logging = false;
let customLogger = () => {};

const setLogging = (_logging) => {
  logging = _logging;
};

const setCustomLogger = (logger) => {
  customLogger = logger;
};

const log = (type, message) => {
  customLogger({ type, message });
  if (logging) {
    console.log(`[${type}] ${message}`);
  }
};

module.exports = {
  logging,
  setLogging,
  setCustomLogger,
  log,
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ffmpeg/ffmpeg/src/utils/log.js
// module id = s6sF
// module chunks = 5